import type { TagResponse } from "@redotech/effect-api-shared/rpc/tag";
import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import FileIcon from "@redotech/redo-icons/file-01.svg";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import type { RedoPlatformRpcClient } from "@redotech/redo-merchant-platform-rpc/client";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { NumberFilterOperator } from "@redotech/redo-model/views/advanced-filters/number-filter";
import type {
  AdvancedTableFilter,
  NumberTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";
import { createAssigneesAdvancedFilter } from "./assignees-filter";
import { ChannelsAdvancedFilter } from "./channels-filter";
import { ClosedAtAdvancedFilter } from "./closed-at-filter";
import { CreatedAtAdvancedFilter } from "./created-at-filter";
import { createCustomerTagsAdvancedFilter } from "./customer-tags-filter";
import { LastCustomerMessageAtAdvancedFilter } from "./last-customer-message-at-filter";
import { LastMerchantMessageAtAdvancedFilter } from "./last-merchant-message-at-filter";
import { LastResponseAtAdvancedFilter } from "./last-response-at-filter";
import { createMentionsAdvancedFilter } from "./mentions-filter";
import { ReadStatusAdvancedFilter } from "./read-status-filter";
import { StatusAdvancedFilter } from "./status-filter";
import { createSupportTicketTagsAdvancedFilter } from "./support-ticket-tags-filter";
import { WordsAdvancedFilter } from "./words-filter";

const NumDraftsFilter: NumberTableFilter = {
  type: AdvancedFilterType.NUMBER,
  Icon: FileIcon,
  operators: [NumberFilterOperator.GREATER_THAN],
  data: supportTicketFilterData[SupportTicketFilterNames.NUM_DRAFTS],
  displayName: "Drafts",
};

const NumSentMessagesFilter: NumberTableFilter = {
  type: AdvancedFilterType.NUMBER,
  Icon: FileIcon,
  operators: [NumberFilterOperator.GREATER_THAN],
  data: supportTicketFilterData[SupportTicketFilterNames.NUM_SENT_MESSAGES],
  displayName: "Sent Messages",
};

export function getSupportTicketAdvancedFilters(options?: {
  effectApi?: EffectApiContext;
  platformRpc?: RedoPlatformRpcClient;
  tags?: TagResponse[];
}): AdvancedTableFilter[] {
  return [
    StatusAdvancedFilter,
    ChannelsAdvancedFilter,
    createAssigneesAdvancedFilter(options?.platformRpc),
    createSupportTicketTagsAdvancedFilter(options?.tags ?? []),
    createCustomerTagsAdvancedFilter(options?.effectApi),
    createMentionsAdvancedFilter(options?.effectApi),
    ReadStatusAdvancedFilter,
    WordsAdvancedFilter,
    CreatedAtAdvancedFilter,
    ClosedAtAdvancedFilter,
    LastResponseAtAdvancedFilter,
    LastCustomerMessageAtAdvancedFilter,
    LastMerchantMessageAtAdvancedFilter,
    // Internal filters for default views (Drafts, Sent) - not shown in filter UI
    NumDraftsFilter,
    NumSentMessagesFilter,
  ];
}
